/**
 * Visualização do Painel: como a frota inteira é desenhada.
 *
 * Não confundir com `panelCharts`, que é a Visualização do Sensor — a forma da
 * faixa de um Ativo *dentro* de um cartão. São eixos diferentes: este decide se
 * existe grade, aquele decide como a faixa é desenhada.
 *
 * O valor é `radial`, e não `sunburst`: é o nome que aparece na tela e na URL.
 * Os artefatos que conversam com o ECharts mantêm `sunburst` no nome, porque é o
 * tipo de série de lá — mesma separação que já existe entre o painel
 * (`communicationStatus`) e o serviço que ele consome (`networkStatus`).
 */
export const panelViews = {
  GRID: 'grid',
  RADIAL: 'radial',
};

export const DEFAULT_PANEL_VIEW = panelViews.GRID;

export function isValidPanelView(value) {
  return Object.keys(panelViews).some(name => panelViews[name] === value);
}

export default panelViews;
